module.exports = __webpack_public_path__ + "static/media/ordenesRoja.5cb1c855.png";